export default "__VITE_ASSET__BvQTdtMq__"